/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import { isEqual, differenceWith } from 'lodash';

export const objectsEqual = (objectA = [], objectB = []) => {
  let difference = [];
  if (objectA.length > objectB.length) {
    difference = differenceWith(objectA, objectB, isEqual);
  } else {
    difference = differenceWith(objectB, objectA, isEqual);
  }
  return difference.length < 1;
};

export const vrsSummation = (results, maxLevel = 1) => {
  const vrsTotal = { value: 0, risk: 0, size: 0 };
  results
    .filter((r) => !r.deleted_at)
    .forEach((result) => {
      if (result.level <= maxLevel) {
        vrsTotal.value += parseInt(
          result.result_type.type_attributes.value || 0,
          10
        );
        vrsTotal.risk += parseInt(
          result.result_type.type_attributes.risk || 0,
          10
        );
        vrsTotal.size += parseInt(
          result.result_type.type_attributes.size || 0,
          10
        );
      }
    }, {});
  return vrsTotal;
};
